var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FormManager',{attrs:{"initialFormValues":_vm.extent_raw_fields,"prettyEndPoint":_vm.prettyEndPoint,"events":_vm.events},on:{"save":_vm.save,"cancel":_vm.cancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }